/** Dùng chung giữa `GiftList` và `GiftForm`. */

/**
 * Gốc URL của site công khai.
 *
 * ⚠️ Cố ý **không** đọc `settings.siteUrl` như `SeoPanel`: dev và prod dùng **chung một
 * DB** (`CLAUDE.md` §0), nên ở local `siteUrl` là `https://tiemnhanho.vn` và nút "Mở" sẽ
 * bắn thẳng ra production — nơi trang vừa tạo chưa tồn tại. Nhánh `DEV` của Vite là thứ
 * duy nhất biết đúng mình đang ở đâu.
 */
const SITE_URL = import.meta.env.DEV ? 'http://localhost:8888' : 'https://tiemnhanho.vn'

export const giftUrl = (slug: string) => `${SITE_URL}/qua-tang/${slug}`

/** Hiện dung lượng cho người đọc: "1,2 MB". Dấu phẩy thập phân theo chuẩn tiếng Việt. */
export function formatBytes(bytes: number | undefined): string {
  if (!bytes) return '—'
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0).replace('.', ',')} KB`
  return `${(bytes / 1024 / 1024).toFixed(1).replace('.', ',')} MB`
}

/** Khớp `GIFT_HTML_MAX` ở `apps/api/src/models/Gift.ts` và `jsonGift` ở `index.ts`. */
export const GIFT_HTML_MAX = 8_000_000

/**
 * Các API bộ nhớ trình duyệt **ném SecurityError** dưới `CSP: sandbox` (opaque origin) —
 * xem `apps/web/app/qua-tang/[slug]/route.ts`.
 *
 * Vì sao phải cảnh báo thay vì nới sandbox: artifact Claude rất hay dùng `localStorage`
 * để nhớ trạng thái, nên tỉ lệ dính cao; mà lỗi đó **câm hoàn toàn** — trang vẫn hiện,
 * chỉ một phần không chạy, không có gì báo. Nới `allow-same-origin` để "chữa" là xoá sạch
 * lớp cách ly duy nhất.
 */
const STORAGE_API = /\b(localStorage|sessionStorage|indexedDB)\b|document\s*\.\s*cookie/

export const usesBrowserStorage = (html: string) => STORAGE_API.test(html)

/** Rút `<title>` có sẵn trong HTML dán vào, để điền sẵn ô Tiêu đề. */
export function extractTitle(html: string): string {
  const m = html.slice(0, 20000).match(/<title\b[^>]*>([\s\S]*?)<\/title\s*>/i)
  if (!m?.[1]) return ''
  return m[1]
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .trim()
}
